import React from 'react';
import Menu from '../../nav/menu';
import Footer from '../../nav/footer';
import useMedia from 'use-media';
import {
    title,
    bodyText1,
    bodyText12,
    bodyText13,
    rightText1,
    rightText12,
    rightText2,
    rightText22,
    rightText3
} from './text';
//import CoffeExample from '../../components/coffeExamples';
import CarroucelImg from '../../components/carroucelImg';
import { generalStyleDivs } from '../../styles.js'
import StylishHeader from '../../components/stylishHeader';
import { textInResolution } from '../../multiFunctions.js';

function CustomizePage() {
    const isLargeScreen = useMedia('(min-width: 601px)');
    const isSmallScreen = useMedia('(max-width: 600px)');
    let screenSize = {
        width: window.screen.width,
        height: window.screen.height
    }

    const mainDiv = {
        display: "flex", 
        flexFlow: "column",
        maxWidth: "1200px", 
        backgroundImage: "url(./img/backgroundSite.png)", 
        backgroundRepeat: "repeat",
        padding: "25px",
        justifyContent: "center"
    }

    const mainDivMobile = {
        display: "flex", 
        flexFlow: "column",
        backgroundImage: "url(./img/backgroundSite.png)", 
        backgroundRepeat: "repeat",
        padding: "25px",
        justifyContent: "center",
        height: "100%",
        width: "100%"
    }
    let divsStyles = {
        fontSize: textInResolution('medium', 'large', 'large', 'large', screenSize)
    }
    const carroucelImg1 = [
        {
            url: '/img/HappyDelivery.png'
        },
        {
            url: '/img/bagOfCoffee2.png'
        },
        {
            url: '/img/bagOfCoffee3.png'
        }
    ];
    return (
        <div>
            <Menu/>
            <div style={{ backgroundColor: "#F4DFBB", justifyContent: "center", display: "flex" }}>
                {isLargeScreen &&
                    <div style={mainDiv}>
                        <div style={{ display: "flex" }}>
                            <div style={{ width: "40%" }}>
                                <div style={{ ...generalStyleDivs, height: "100%" }}>
                                    <StylishHeader marginLeft="0px" headerText={title} />
                                    <div style={{ margin: "10px",  textAlign: "justify", ...divsStyles }}>
                                        {bodyText1}<br/><br/>
                                        {bodyText12}<br/><br/>
                                        {bodyText13}<br/><br/>
                                    </div>
                                </div>
                            </div>
                            <div style={{ width: "60%" }}>
                                <div style={{ width: "100%", display: "flex", margin: "10px", ...generalStyleDivs }}>
                                    <div style={{ margin:"10px", width: '40%',  display: 'flex', justifyContent: 'center', alignItems: "center" }}>
                                        <img src="/img/spoonCoffee.png" width="100%" style={{ borderRadius: "30px", maxWidth: "300px", maxHeight: "300px" }} alt=''/>
                                    </div>
                                    <div style={{ width: "60%", padding: "10px", display: 'flex', alignItems: 'center', lineHeight: "1.5" }}>
                                        <div style={{ ...divsStyles }}>
                                            {rightText1}<br/><br/>
                                            {rightText12}<br/><br/>
                                        </div>
                                    </div>
                                </div>
                                <div style={{ width: "100%", display: "flex", margin: "10px", ...generalStyleDivs }}>
                                    <div style={{ margin:"10px", width: '40%',  display: 'flex', justifyContent: 'center', alignItems: "center" }}>
                                        <img src="/img/gainCoffee.png" width="100%" style={{ borderRadius: "30px", maxWidth: "300px", maxHeight: "300px" }} alt=''/>
                                    </div>
                                    <div style={{ width: "60%", padding: "10px", display: 'flex', alignItems: 'center', lineHeight: "1.5" }}>
                                        <div>
                                            {rightText2}<br/><br/>
                                            {rightText22}<br/><br/>
                                        </div>
                                    </div>
                                </div>
                                <div style={{ width: "100%", display: "flex", margin: "10px", ...generalStyleDivs }}>
                                    <div style={{ margin:"10px", width: '40%',  display: 'flex', justifyContent: 'center', alignItems: "center" }}>
                                        <img src="/img/HappyDelivery.png" width="100%" style={{ borderRadius: "30px", maxWidth: "300px", maxHeight: "300px" }} alt=''/>
                                    </div>
                                    <div style={{ width: "60%", padding: "10px", display: 'flex', alignItems: 'center', lineHeight: "1.5" }}>
                                        <div>{rightText3}</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                }
                {isSmallScreen &&
                    <div style={mainDivMobile}>
                        <StylishHeader headerText={title} />
                        <div style={{ display: "flex", flexFlow: "row", height: "40%",paddingBottom: "10px" }}>
                            <div style={{ fontSize: "x-large", margin: "20px", ...generalStyleDivs }}>
                                <div style={{ margin: "10px" }}>
                                    {bodyText1}<br/><br/>
                                    {bodyText12}<br/><br/>
                                    {bodyText13}<br/><br/>
                                </div>
                            </div>
                        </div>
                        <div style={{ display: "flex", justifyContent: "center", height: "250px", marginButtom: "10px" }}>
                            <CarroucelImg carroucelImg={carroucelImg1} arrows="black" />
                        </div>
                        <div style={{ fontSize: "x-large", textAlign: "justify", ...generalStyleDivs,marginTop: "50px" }}>
                           <div style={{ margin: "10px" }}>
                                {rightText1}<br/><br/>
                                {rightText12}<br/><br/>
                            </div>
                           <div style={{ margin: "10px" }}>
                                {rightText2}<br/><br/>
                                {rightText22}<br/><br/>
                            </div>
                           <div style={{ margin: "10px" }}>{rightText3}</div>
                        </div>
                    </div>
                }
            </div>
            <Footer/>
        </div>
        
    )
}

export default CustomizePage;